import React, { useState } from 'react';
import './Help.css';
import IconButton from '../IconButton/IconButton';
import { useTranslate } from '../../hooks/context/useTranslate';
import Popover from '../Popover/Popover';

interface IHelpProps {
  children: React.ReactNode;
  help?: string;
}

export default function Help({ children, help }: IHelpProps) {
  const { t } = useTranslate();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={'help'}>
      <div className="help-text">{children}</div>
      {help && (
        <Popover
          isOpen={isOpen}
          onClickOutside={() => setIsOpen(false)}
          align="end"
          showBackdrop
          className="help-popover"
          content={
            <div className="ion-padding">
              <p>
                <b>{t('help')}</b>
                <br />
                {help}
              </p>
            </div>
          }
        >
          <div slot="end" className="help-button">
            <IconButton onClick={() => setIsOpen(true)}>?</IconButton>
          </div>
        </Popover>
      )}
    </div>
  );
}
